import { createFeatureSelector } from "@ngrx/store";
import { expenseState } from "./expense.reducer";


export const getExpenseState = createFeatureSelector<expenseState>("expenses");

